/**
 * API reducer
 */
import produce from 'immer';

import {
	SELECT_API,
	UPDATE_FIELD,
	LOAD_RESULTS,
	LOAD_RESULTS_SUCCESS,
	LOAD_RESULTS_FAILURE,
} from '../actions/apiActions';
import availableApis from '../apiConfigurations';

// The initial state of the App
export const initialState = {
	availableApis,
	currentApiId: null,
};

/**
 * The main reducer for this app.
 *
 * @param {*} state - The Redux store.
 * @param {*} action - The dispatched action.
 */
export default produce((draft, action) => {
	const { type, payload } = action;

	switch (type) {
		case SELECT_API: {
			draft.currentApiId = payload;
			break;
		}
		case UPDATE_FIELD: {
			const { fieldId, value } = payload;
			const { currentApiId } = draft;

			draft.availableApis = draft.availableApis.map((api) => {
				if (api.id !== currentApiId) return api;

				return {
					...api,
					fields: api.fields.map((field) => {
						if (field.id !== fieldId) return field;

						return {
							...field,
							value,
						};
					}),
				};
			});

			break;
		}
		case LOAD_RESULTS: {
			const { currentApiId } = draft;
			draft.availableApis = draft.availableApis.map((api) => {
				if (api.id !== currentApiId) return api;

				return {
					...api,
					loading: true,
					error: null,
					totalResults: 0,
					timeTaken: 0,
					facets: null,
					results: null,
					camPayload: null,
				};
			});

			break;
		}
		case LOAD_RESULTS_SUCCESS: {
			const { currentApiId } = draft;
			const { data, totalResults, timeTaken, facets, camPayload } = payload;
			draft.availableApis = draft.availableApis.map((api) => {
				if (api.id !== currentApiId) return api;

				return {
					...api,
					loading: false,
					totalResults,
					timeTaken,
					facets,
					results: data,
					camPayload,
				};
			});

			break;
		}
		case LOAD_RESULTS_FAILURE: {
			const { currentApiId } = draft;
			draft.availableApis = draft.availableApis.map((api) => {
				if (api.id !== currentApiId) return api;

				return {
					...api,
					loading: false,
					error: payload,
				};
			});

			break;
		}
		default:
			// Nothing to do
			break;
	}
}, initialState);
